import React from "react";
import TopBar from "../Components/TopBar";
import TopBarTopics from "../Components/TopBarTopics";
import TopBarAds from "../Components/TopBarAds";
import NewsSec from "../Components/NewsSec";
import FooterTop from "../Components/FooterTop";
import FooterBottom from "../Components/FooterBottom";
import MyFooter from "../Components/MyFooter";
import OpenNews from "../Components/OpenNews";
import { useSearchParams } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      <TopBar />

      <OpenNews />
      <TopBarAds />
      <FooterBottom />
      <MyFooter />
    </div>
  );
}

export default Home;
